import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  Icon: {
    width: 28,
    height: 6,
    marginTop:12    
  },
});
